import React, { useEffect, useState } from 'react';
import FileUploadTemplate from '../../../components/common/FileUpload/FileUploadTemplate';
import { useSalesFileContext } from '@/context/salesFileContext/SalesFileContextProvider';
import { Input } from '@/components';

const Upload = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { salesFile, setSalesFile, initialState, uploadSalesFileAPI } =
    useSalesFileContext();
  const [error, setError] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);

  const months = [
    'JANUARY',
    'FEBRUARY',
    'MARCH',
    'APRIL',
    'MAY',
    'JUNE',
    'JULY',
    'AUGUST',
    'SEPTEMBER',
    'OCTOBER',
    'NOVEMBER',
    'DECEMBER',
  ];

  const isValidFileName = (fileName, file) => {
    const regex = /^JAY-stkmove-(\d{6})\.csv$/;
    const match = fileName.match(regex);
    const isValid = match !== null;
    if (isValid) {
      const dateStr = match[1];
      const year = `20${dateStr.substring(0, 2)}`;
      const month = dateStr.substring(2, 4);
      const day = dateStr.substring(4, 6);
      const date = new Date(`${year}-${month}-${day}`);
      const isValidDate =
        date.getFullYear() === parseInt(year) &&
        date.getMonth() + 1 === parseInt(month) &&
        date.getDate() === parseInt(day);
      if (isValidDate) {
        setSalesFile({
          ...salesFile,
          isDaily: true,
          fileDate: `${year}-${month}-${day}`,
          fileMonth: [],
          fileYear: date.getFullYear(),
        });
        setIsDisabled(false);
        return true;
      } else {
        setSalesFile({
          ...salesFile,
          isDaily: false,
          fileDate: '',
          fileMonth: [],
          fileYear: date.getFullYear(),
        });
        return false;
      }
    }
    return isValid;
  };

  const handleFilesSelected = (files) => {
    const file = files[0];
    if (isValidFileName(file.name, file)) {
      setSelectedFiles(files);
    } else {
      setSelectedFiles(files);
      setSalesFile({
        ...salesFile,
        isDaily: false,
        fileDate: '',
        fileMonth: [],
      });
    }
  };

  useEffect(() => {
    checkErrorAndSubmit();
  }, [salesFile.fileYear, salesFile.fileMonth]);

  useEffect(() => {
    if (!salesFile.file) {
      setSalesFile(initialState);
    }
  }, [salesFile.file]);

  const handleMonthChange = (month) => {
    setSalesFile((prevState) => {
      const fileMonth = prevState.fileMonth.includes(month)
        ? prevState.fileMonth.filter((m) => m !== month)
        : [...prevState.fileMonth, month];
      return { ...prevState, fileMonth };
    });
  };

  const checkIsYearValid = (year) => {
    if (year === '') {
      return false;
    }
    const currentYear = new Date().getFullYear();
    return year > 2000 && year <= currentYear;
  };

  const checkErrorAndSubmit = () => {
    const year = parseInt(salesFile.fileYear, 10);
    if (salesFile.isDaily === false) {
      if (checkIsYearValid(year) === false) {
        setError('Please select a valid year');
        setIsDisabled(true);
        return;
      } else if (salesFile.fileMonth.length === 0) {
        setError('Please select at least one month');
        setIsDisabled(true);
        return;
      } else {
        setIsDisabled(false);
        setError('');
      }
    } else {
      setError('');
    }
  };

  const handleSubmission = async () => {
    if (selectedFiles.length === 1) {
      await uploadSalesFileAPI(selectedFiles[0]);
      setSelectedFiles([]); // Clear selected files after successful upload
      setError(null);
      setSalesFile(initialState);
    } else {
      alert('Please select a file to upload.');
    }
  };

  const renderMonthCheckboxes = () => {
    return (
      <>
        <div className="my-2">
          <Input
            name="year"
            type="number"
            label="Year"
            value={salesFile.fileYear}
            onChange={(e) =>
              setSalesFile({
                ...salesFile,
                fileYear: e.target.value,
              })
            }
            placeholder="Enter Year"
          />
        </div>
        <h3 className="text-lg font-medium text-gray-700 mb-4">
          Select Months
        </h3>
        <div className="grid grid-cols-3 my-2 gap-3">
          {months.map((month, index) => (
            <div key={month} className="">
              <div className="">
                <input
                  type="checkbox"
                  id={month}
                  name={month}
                  value={month}
                  checked={salesFile.fileMonth.includes(month)}
                  onChange={() => handleMonthChange(month)}
                  className="mr-2"
                />
                <label htmlFor={month} className="text-gray-700">
                  {month}
                </label>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };

  return (
    <div className="flex justify-center">
      <div>
        <h2 className="text-2xl font-semibold text-gray-800 mb-4"></h2>
        <p className="text-gray-500 mb-6 text-center">
          Please upload a CSV file .
        </p>

        <p className="text-red-500 mb-6 text-center font-poppins">
          <span className="font-bold">*Note:</span> Remove header row from sales
          file before upload
        </p>

        <FileUploadTemplate
          acceptedFileTypes={['.csv']}
          onFilesSelected={handleFilesSelected}
          multiple={false}
          maxFiles={1}
          onUpload={handleSubmission}
          isDisabled={isDisabled}
          error={error}>
          {' '}
          {salesFile.isDaily == false && <>{renderMonthCheckboxes()}</>}
        </FileUploadTemplate>
      </div>
    </div>
  );
};

export default Upload;
